"use client";

import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
function StoriesGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[520px] bg-[var(--muted)] animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <p className="text-center font-default text-[var(--muted-foreground)]">
        {"Articles are currently unavailable. Please try again later."}
      </p>;
  }
  if (posts.length === 0) {
    return <p className="text-center font-default text-[var(--muted-foreground)]">
        {"No articles found. Check back for new insights soon."}
      </p>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const category = post.categories && post.categories.length > 0 ? post.categories[0] : null;
      return <Card key={post.id} data-index={i} className="group flex flex-col overflow-hidden border border-[var(--border)] bg-[var(--card)] p-5 transition-all duration-400 hover:-translate-y-1 hover:shadow-lg">
            {}
            <div className="relative h-[260px] w-full overflow-hidden rounded-lg">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" /> : <div className="h-full w-full bg-[var(--secondary)]" />}
            </div>

            <CardContent className="flex flex-1 flex-col px-2 pb-2 pt-6">
              {category && <Badge className="mb-4 w-fit rounded-lg border-transparent bg-[var(--secondary)] px-4 py-1 text-xs font-semibold tracking-wide text-[var(--primary)] hover:bg-[var(--secondary)]">
                  {category.name}
                </Badge>}

              <h3 className="mb-3 font-serif text-[1.375rem] font-medium leading-snug text-[var(--primary)]">
                {post.title}
              </h3>

              {post.excerpt && <p className="mb-6 line-clamp-2 font-default text-base leading-relaxed text-[var(--muted-foreground)]" dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />}

              <div className="mt-auto">
                <Link to={post.link || "#"} className="inline-flex items-center gap-1.5 font-default text-sm font-semibold text-[var(--primary)] transition-all hover:text-[var(--primary)]/70">
                  <span>{"Read article"}</span>
                  <ArrowRight className="h-4 w-4 transition-transform duration-240 group-hover:translate-x-1" strokeWidth={2} />
                </Link>
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function Perspectives() {
  return <section data-section-id="25326" id="fresh-perspectives" className="relative overflow-hidden bg-[var(--background)] ![padding:100px_0px_100px_0px]">
      <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
        {}
        <div className="mx-auto mb-16 max-w-[880px] text-center md:mb-24">
          <div className="mb-6 text-[0.8125rem] font-semibold uppercase tracking-[0.16em] text-[var(--primary)]">Latest articles</div>

          <h2 className="mb-5 font-serif text-[clamp(2rem,4.2vw,3.75rem)] font-medium leading-[1.08] tracking-[-0.015em] text-[var(--primary)]">Common sense perspectives on <br />screen time</h2>

          
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 6,
        order: "desc",
        orderby: "modified",
        status: ["publish"]
      }}>
          <StoriesGrid />
        </PostsProvider>

        {}
        <div className="mt-16 flex justify-center md:mt-24">
          <Link to="/WhatAreKidsWatchingPage"><Button className="rounded-lg bg-[var(--primary)] px-8 py-4 font-default text-base font-bold text-[var(--primary-foreground)] hover:bg-[var(--primary)]/90">
              {"Explore all topics"}
              <ArrowRight className="ml-1 h-4 w-4" strokeWidth={2} />
            </Button></Link>
        </div>
      </div>
    </section>;
}